import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { FC, PropsWithChildren } from 'react';

import {
  PrelineColourVariant,
  simplePrelineColourVariant,
} from '@payaca/types/preline';
import { clstx } from '@payaca/utilities/cvaMerge';

const getColourClasses = (colour: PrelineColourVariant) => {
  switch (colour) {
    case 'black':
      return {
        bg: 'bg-gray-300',
        text: 'text-gray-800',
      };

    case 'green':
      return {
        bg: 'bg-green-300',
        text: 'text-green-800',
      };
    case 'blue':
      return {
        bg: 'bg-blue-300',
        text: 'text-blue-800',
      };
    case 'red':
      return {
        bg: 'bg-red-300',
        text: 'text-red-800',
      };
    case 'yellow':
      return {
        bg: 'bg-yellow-300',
        text: 'text-yellow-800',
      };
    case 'white':
      return {
        bg: 'bg-white/10',
        text: 'text-white',
      };
    case 'purple':
      return {
        bg: 'bg-purple-500',
        text: 'text-white',
      };
    case 'orange':
      return {
        bg: 'bg-orange-300',
        text: 'text-orange-800',
      };
    case 'gray':
    default:
      return {
        bg: 'bg-gray-300',
        text: 'text-gray-800',
      };
  }
};

export const VerticalStepper_: FC<PropsWithChildren> = ({ children }) => {
  return <div className="space-y-4">{children}</div>;
};

const Step: FC<
  PropsWithChildren<{
    title: string;
    icon?: TIconName;
    colour?: simplePrelineColourVariant;
    isIncomplete?: boolean;
  }>
> = ({ children, colour = 'gray', icon, title, isIncomplete }) => {
  const colourClasses = getColourClasses(colour);

  return (
    <div className="w-full flex flex-row gap-4 typography:prose">
      <div className="shrink flex flex-col items-center gap-2">
        <div
          className={clstx(
            'w-8 h-8 rounded-full flex items-center justify-center',
            colourClasses.bg,
            colourClasses.text
          )}
        >
          {icon && <UntitledIcon name={icon} className="w-3/5 h-3/5" />}
        </div>
        <div className={clstx('grow w-px', colourClasses.bg)}></div>
        {!!isIncomplete && <div className="grow w-px bg-gray-200"></div>}
      </div>
      <div className="grow space-y-2 mt-1">
        <div className="min-h-6 flex items-center">
          <h4>{title}</h4>
        </div>
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};

export const VerticalStepper = Object.assign(VerticalStepper_, {
  Step,
});
